import React, { useState, useRef } from 'react';
import FileManager from './FileManager';
import { FileUploader } from './FileUploader';
// Импортируем новые компоненты разделов с обновленными названиями
import WarehouseItemsSection from './Section/WarehouseItemsSection';
import SelectedDocumentSection from './Section/SelectedDocumentSection';
import ProcessedDocumentsSection from './Section/ProcessedDocumentsSection';
import AllDocumentsSection from './Section/AllDocumentsSection';
import DataPacketsSection from './Section/DataPacketsSection';

const tabs = [
    { label: '🏪', title: 'Warehouse Items', component: WarehouseItemsSection },
    { label: '📄', title: 'Selected Document', component: SelectedDocumentSection },
    { label: '✅', title: 'Processed Documents', component: ProcessedDocumentsSection },
    { label: '📊', title: 'All Documents', component: AllDocumentsSection },
    { label: '📦', title: 'Data Packets', component: DataPacketsSection },
];

const MainArea = ({ children, onOpenPrint }) => {
    const [activeTab, setActiveTab] = useState(0);
    const fileManagerRef = useRef();

    const handlePrint = () => {
        // Демонстрационные данные для печати
        const samplePrintData = [
            { id: 1, name: 'Товар из вкладки', article: 'ART001', supplier: 'Основной поставщик', barcode: '1234567890123', quantity: 5 },
            { id: 2, name: 'Второй товар', article: 'ART002', supplier: 'Дополнительный поставщик', barcode: '9876543210987', quantity: 2 }
        ];
        onOpenPrint?.(samplePrintData);
    };

    return (
        <div
            style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                height: '100%',
                minHeight: 0,
                margin: 0,
                padding: 0
            }}
        >
            <div style={{
                display: 'flex',
                borderBottom: window.innerWidth < 768 ? 'none' : '1px solid #ccc',
                flexWrap: 'wrap',
                flexShrink: 0,
                margin: 0,
                padding: 0
            }}>
                {tabs.map((tab, idx) => (
                    <button
                        key={tab.label}
                        style={{
                            flex: 1,
                            padding: window.innerWidth < 768 ? '12px 4px' : '8px',
                            background: activeTab === idx ? 'white' : 'white',
                            border: 'none',
                            borderBottom: activeTab === idx ? '3px solid #1976d2' : '3px solid transparent',
                            color: '#1976d2',
                            fontWeight: activeTab === idx ? 'bold' : 'normal',
                            cursor: 'pointer',
                            fontSize: window.innerWidth < 768 ? '20px' : '24px',
                            minHeight: window.innerWidth < 768 ? '44px' : '50px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            margin: 0
                        }}
                        onClick={() => setActiveTab(idx)}
                        title={tab.title}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Контент активной вкладки */}            <div
                style={{
                    flex: 1,
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    margin: 0,
                    padding: 0
                }}
            >
                {React.createElement(tabs[activeTab].component)}
            </div>

            {/* Оверлей (модалка и пр.) */}
            {children && (
                <div
                    style={{
                        position: 'absolute',
                        top: 60,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 10,
                        background: 'rgba(255,255,255,0.98)',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        padding: 24,
                        borderRadius: 8,
                        overflow: 'auto'
                    }}
                >
                    {children.props?.onClose && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button
                                onClick={children.props.onClose}
                                style={{
                                    background: '#ef4444',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 4,
                                    padding: '6px 16px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    marginBottom: 12
                                }}
                            >
                                Закрыть
                            </button>
                        </div>
                    )}
                    {children}
                </div>
            )}
        </div>
    );
};

export default MainArea;
